import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import { PROFIL, REQUEST_PASS_TYPE } from '../../../constants/enum';
import Radio from '@mui/material/Radio';
import { TextField } from '@mui/material';
import MyButton from '../../Layout/MyButton';
import { faCheck, faXmark } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import MySelect from '../../Layout/MySelect';
import { useDispatch, useSelector } from 'react-redux';
import ControlledTextField from '../../Controlled/RequestPass/ControlledTextField';
import { setReference, updateReference } from '../../../actions/RequestPassAction';

const StepControleRef = React.memo((props) => {
    const { refs, profil, reference, demandePassage, demandePassageStyle, notAbleToChange, departments, validSteps, onNextStep } = props;
    const dispatch = useDispatch();

    const editable = validSteps.step1 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT) || notAbleToChange;

    const handleChange = (e) => {
        const { name, value } = e.target;
        dispatch(updateReference(name, value));
    };

    return (
        <div ref={(divRef) => refs.current['step-infos_gen'] = divRef} className='step'>
            <div className='step-content'>
                <div style={{ display: 'flex', flexDirection: 'column', height: '90%' }}>
                    <h3 className='modal-step-title'>Informations générales du dossier</h3>
                    <div className='row-without-height'
                         style={{ flexWrap: 'nowrap', justifyContent: 'left', height: '' }}>
                        <FormControl style={{ margin: '20px' }}>
                            <FormLabel>Type de demande de passage</FormLabel>
                            <RadioGroup row name='typeDemande' value={reference?.typeDemande}
                                        onChange={handleChange}> <FormControlLabel
                                value={REQUEST_PASS_TYPE.SUPERIEUR} control={<Radio />}
                                label='Passage supérieur'
                                disabled={editable} />
                                <FormControlLabel value={REQUEST_PASS_TYPE.AUTOROUTE} control={<Radio />}
                                                  label='Passage sur autoroute' disabled={editable} />
                            </RadioGroup>
                        </FormControl>
                    </div>
                    <div className='row-without-height' style={{ flexWrap: 'nowrap', justifyContent: 'left' }}>
                        <ControlledTextField
                            label='Ref DDT/Ref Militaire'
                            type='text'
                            name='numDossier'
                            value={reference?.numDossier || ''}
                            style={demandePassageStyle.textFieldFixed}
                            autoComplete='off'
                            onChange={handleChange}
                            inputProps={{ maxLength: 15 }}
                            disabled={editable}
                        />
                    </div>

                    <div className='row-without-height' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        height: 'fit-content',
                    }}>
                        <FormControl style={{ minWidth: 300, margin: 0 }}>
                            <MySelect labelClass={'select-label-black'}
                                      label='Départements traversés'
                                      type='text'
                                      name='departments'
                                      value={reference?.departments}
                                      datas={departments}
                                      multiple={true}
                                      autoComplete='off'
                                      handleChange={handleChange}
                                      disabled={editable}
                                      disableClass={true}
                                      displayLabel={true}
                                      maxLength={reference?.typeDemande === REQUEST_PASS_TYPE.SUPERIEUR ? 1 : null}
                            />
                        </FormControl>
                    </div>
                </div>
                {(profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && demandePassage.id !== 0 &&
                    <div className='row' style={{ justifyContent: 'flex-end', alignItems: 'center', height: '80px' }}>
                        <MyButton
                            style={validSteps['step1'] ? 'buttonRejected' : 'buttonValidation'}
                            label={validSteps['step1'] ? 'Rejeter l\'étape' : 'Valider l\'étape'}
                            icon={validSteps['step1'] ? faXmark : faCheck}
                            onClick={() => {
                                onNextStep(null, null, 1);
                            }}
                        />
                    </div>
                }
            </div>
        </div>);
});

export default StepControleRef;